import { AuthInitResponse, LoginParam, LoginResponse } from '~types/auth'
import api from '~utils/api'

class AuthService {
	private token: string = ''

	constructor() {
		const token = localStorage.getItem('x-auth-token')
		if (token) {
			this.setToken(token)
		}
	}

	getToken(): string {
		return this.token
	}
	setToken(token: string, save: boolean = false) {
		this.token = token
		if (save) {
			localStorage.setItem('x-auth-token', token)
		}
	}
	revokeToken() {
		this.token = ''

		delete api.defaults.headers.common['Authorization']
		localStorage.removeItem('x-auth-token')
	}

	async login(data: LoginParam): Promise<boolean> {
		try {
			const { token } = await api.post<void, LoginResponse>(
				'/ag/login',
				data
			)

			this.setToken(token, true)
			return false
		} catch (e) {
			return Promise.reject(e)
		}
	}

	async getAuthInit(): Promise<AuthInitResponse> {
		try {
			const res = await api.get<void, AuthInitResponse>('/ag/session')

			return res

		} catch (e) {
			return Promise.reject(e)
		}
	}
}

export default new AuthService()
